import Cookies from "js-cookie";
import React, { useState } from "react";
import { BiLinkExternal } from "react-icons/bi";
import { ThreeDots } from "react-loader-spinner";
import api from "src/rest/api";

const AccessForm: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  function Authenticate(isStudent: boolean) {
    setLoading(true);
    api
      .post<string>("/admin/auth", { email, isStudent })
      .then((res) => {
        if (res.data.startsWith("https://aluno.")) window.open(res.data);
        else {
          const access = new URLSearchParams(res.data).get("xaccess");
          if (access) {
            Cookies.set("ad@access", Cookies.get("@access")!, { expires: 30 });
            Cookies.set("@access", access, { expires: 30 });
            window.location.reload();
          }
        }
      })
      .catch((err) => alert(err))
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <div className="mt-10">
      <h2 className="text-xl font-bold">Admin Auth</h2>
      {loading ? (
        <div className="m-auto">
          <ThreeDots height={38} width={38} color="black" />
        </div>
      ) : (
        <div className="mb-4 flex flex-row">
          <input
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="User email..."
            className="flex-1 rounded border border-zinc-200 p-2"
          />
          <button
            className="ml-2 flex items-center justify-center gap-2 rounded bg-blue-500 px-2 text-xs uppercase text-white"
            onClick={() => Authenticate(false)}
          >
            <p>Trainer</p>
            <BiLinkExternal />
          </button>
          <button
            className="ml-2 flex items-center justify-center gap-2 rounded bg-blue-500 px-2 text-xs uppercase text-white"
            onClick={() => Authenticate(true)}
          >
            <p>Student</p>
            <BiLinkExternal />
          </button>
        </div>
      )}
    </div>
  );
};

export default AccessForm;
